import { BloodCellPosition } from './BloodCellPosition';
import { BloodCell } from './BloodCell';
import { GameEvent } from './../core/GameAbstract';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from '../core/GameAbstract';
import Template from 'frontools/data/Template';
import { autobind } from 'frontools/decorators/Autobind';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';
import { GameMode, GameManager } from '../core/GameManager';
import GameTimer from '../core/components/GameTimer';
import GameScore from '../core/components/GameScore';
import Context from 'frontools/core/Context';
import Breakpoint from 'frontools/core/Breakpoint';

export class GlobulesAGogo extends GameAbstract {

    public static instance                  : GlobulesAGogo;
    //public static TIME_SCALE_MAX_FACTOR     : number                        = 3.5;
    public static TIME_SCALE_MAX_FACTOR     : number;

    private _levelWrapper                   : PIXI.Container                = new PIXI.Container;
    private _bloodCellsContainer            : PIXI.Container;

    private _timeScale                      : number                        = 1;
    private _background                     : PIXI.extras.TilingSprite;
    private _bloodCellPosition              : BloodCellPosition;
    private _soundsSequence                 : number[]                      = [1, 1, 2, 3, 4 , 5, 6, 7, 7, 8, 9 , 10];
    private _stopBloodCellCreation          : boolean                       = false;
    private _bloodCellsClickedCount         : number                        = 0;

    constructor() {
        super({
            time: 30,
            results: [
                '0-20', //Bas      
                '21-49', //Moyen
                '50-9999' //Élevé  
            ],
            /**
             * Créer un asset pour le globule avec init: true
             * Peut être appelé par Assets.sprites[name]
             */
            assets: [
                { name: 'globules', url: 'sprite/globules/globules.json' },

                { name: 'bloodCell1', url: 'audio/blood_cell/1.mp3' },
                { name: 'bloodCell2', url: 'audio/blood_cell/2.mp3' },
                { name: 'bloodCell3', url: 'audio/blood_cell/3.mp3' },
                { name: 'bloodCell4', url: 'audio/blood_cell/4.mp3' },
                { name: 'bloodCell5', url: 'audio/blood_cell/5.mp3' },
                { name: 'bloodCell6', url: 'audio/blood_cell/6.mp3' },
                { name: 'bloodCell7', url: 'audio/blood_cell/7.mp3' },
                { name: 'bloodCell8', url: 'audio/blood_cell/8.mp3' },
                { name: 'bloodCell9', url: 'audio/blood_cell/9.mp3' },
                { name: 'bloodCell10', url: 'audio/blood_cell/10.mp3' },

                { name: 'error1', url: 'audio/errors/1.mp3' },
                { name: 'error2', url: 'audio/errors/2.mp3' },

                { name: 'music', url: 'audio/music.mp3', howlConfig: { loop: true }},
                { name: 'end', url: 'audio/end.mp3' },

                { name: 'background', url: 'img/bg_stage.png' }
            ]
        });

        this._bloodCellPosition = new BloodCellPosition();

        // Pseudo singleton
        GlobulesAGogo.instance = this;
    };


    /*
     * @core override
     * _onPreloadComplete - Called when the preload has been completed
     * 
     */
    protected _onPreloadComplete() {
        super._onPreloadComplete();
        this._bloodCellsContainer = new PIXI.Container();
    };

    /*
     * @core override
     * _prepare - Prepare the game components and then starts the countdown
     * 
     */    
    protected _prepare() {
        this._bloodCellsContainer.addChild(this._drawRect(320, this._screenHeight, 0x000000, 0));
        this._background = Assets.sprites['background'] as PIXI.extras.TilingSprite;
        this._background.width = this._screenWidth;
        this._stage.addChild(this._background);
        this._stage.addChild(this._bloodCellsContainer);

        this._bloodCellsContainer.interactive = true;
        this._bloodCellsContainer.buttonMode = true;
        this._bloodCellsContainer.on(GameEvent.CLICK, this._onClick, this);
        this._bloodCellsContainer.on(GameEvent.TAP, this._onClick, this);

        if (Breakpoint.isHigherThan('mobile')) GlobulesAGogo.TIME_SCALE_MAX_FACTOR = 4;//3.5;
        else GlobulesAGogo.TIME_SCALE_MAX_FACTOR = 4.5;


        // Trigger components positioning
        // Note: This will initialise core game components and start the countdown
        super._prepare(); 
    };

    private _drawRect(w: number = this._screenWidth, h: number = this._screenHeight, color: number = 0xFFFFFF, alpha: number = 1) {
        let rect = new PIXI.Graphics;
        rect.beginFill(color, alpha);
        rect.drawRect(0, 0, w, h);
        rect.endFill();
        return rect;
    };

    /*
     * @core override
     * _start - Starts the game
     *  
     */
    protected _start() {
        super._start();
        
        Assets.sounds['music'].play();
        TweenMax.to(this, this._gameTimer.time, { _timeScale: GlobulesAGogo.TIME_SCALE_MAX_FACTOR, ease: (SteppedEase as any).config(30) });  //Higher the timeScale to reach is, the faster the ennemies falling will be
        this._generateBloodCells();
    };

    /*
     * @core override
     * _onTimerComplete - on game timer complete handler
     * @param {event} e - Event
     * 
     */
    protected _onTimerComplete(e) {
        super._onTimerComplete(e);
        this._stopBloodCellCreation = true;
        Assets.sounds['music'].stop();
        Assets.sounds['end'].play();
    };

    /**
     * Handles clicks on the stage, not on a blood cell.
     * @param e
     */
    private _onClick(e) {
        if (e.hasOwnProperty("type") && e.type == "BLOOD_CELL_CLICKED") {
            this._gameScore.add(1);
            Assets.sounds['bloodCell' + this._soundsSequence[this._bloodCellsClickedCount]].play();
            
            if (this._bloodCellsClickedCount < this._soundsSequence.length - 1) {
                this._bloodCellsClickedCount += 1;
            } else {
                this._bloodCellsClickedCount = 0;
            }

        } else {
            this._gameScore.remove(1);
            Assets.sounds['error' + NumberUtils.random(1, 2)].play();
        }
    }

    protected _end() {
        super._end();
    }

    private _generateBloodCells() {
        this._createNewBloodCell();
        this._gameTimer.addListener(GameTimer.TIME_CHANGE, function(e) {
            let musicRate = (e.progress - 0.15) * 0.5;

            // if (e.progress >= 0.99) this._stopBloodCellCreation = true; // Stop creating bads after a certain time
            if (e.progress >= 0.15) {
                if (!isNaN(musicRate)) Assets.sounds['music'].rate(1 + musicRate);
            }
        }.bind(this))
    }

    @autobind
    private _createNewBloodCell() {
        if (!this._stopBloodCellCreation) {
            let bloodCell = new BloodCell(this._bloodCellPosition.getColumn());
            bloodCell.addListener(BloodCell.TRIGGER_NEW_ONE, this._createNewBloodCell);
            bloodCell.addListener(BloodCell.CLICKED, this._onClick.bind(this));
            this._bloodCellsContainer.addChild(bloodCell.container);
        }
    }

    public get screenHeight() : number {
        return this._screenHeight;
    }

    public get bloodCellsContainer() : PIXI.Container {
        return this._bloodCellsContainer;
    }

    public get screenWidth() : number {
        return this._screenWidth;
    }

    public get resolution() : number {
        return this._resolution;
    }

    public get timeScale() : number {
        return this._timeScale;
    }

    /*
     * @core override
     * _resize - Resize handler
     * @param {event} e - Event
     * 
     */
    protected _resize(e?: Event) {
        super._resize(e);

        if (this._gameMode === GameMode.PLAYING || typeof e === 'undefined') {
            // resize containers
            this._bloodCellsContainer.y = 0;
            this._bloodCellsContainer.x = (this._screenWidth / 2) - 160; // 160 = 320 / 2.
            this._background.width = this._screenWidth;
        }
    };

}